import '../App.css';
import MainContent from '../components/MainContent';
import { MouseEventHandler, useEffect, useRef, useState } from 'react';
import { BackButton, BackgroundStyle, BigHeading, ButtonContainer, DocumentButton, LabelContainer, LightBlueContainer, ShortBlueButton, DeleteButton } from '../assets/style';
import SearchInput from '../components/SearchInput';
import dayjs from 'dayjs';
import SearchDatePicker from '../components/SearchDatePicker';
import FormButton from '../components/FormButton';
import { Box, FormControl, IconButton, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { deleteIcon } from '../assets/imgs';
import axios from 'axios';
import FormInput from '../components/FormInput';
import FormDatePicker from '../components/FormDatePicker';
import React from 'react';
import FormLabel from '../components/FormLabel';
import { height, minWidth } from '@mui/system';
import FormCheckbox from '../components/FormCheckbox';
import { useLocation, useNavigate } from 'react-router';
import { equipmentPageName } from '../components/PageName';
import { useLazyGetEquipmentByIdQuery, useLazyGetFileQuery } from '../features/equipment/EquipmentSlice';
import { useTranslation } from "react-i18next";

const EquipmentDetailPage = () => {
    const navigate = useNavigate();
    const getLocation = useLocation();
    const equipmentId = getLocation.state;
    const [getEquipmentById, equipmentById] = useLazyGetEquipmentByIdQuery();
    const [getFile, file] = useLazyGetFileQuery();
    const { t, i18n } = useTranslation();

    useEffect(() => {
        //console.log(equipmentId);
        getEquipmentById(equipmentId).then((res) => {
            if (res.status == 'fulfilled') {
                console.log(res?.data);
            }
        })
    }, [])

    const fileUrl = (file: any) => {
        getFile(file.Id).then((res) => {
            if (res?.data != undefined) {
                const link = document.createElement('a');
                link.href = res?.data?.url;
                link.download = file.Name;
                link.click();
            }
        })
    }

    useEffect(() => {
        //if(file?.status == 'fulfilled'){
        //    if(file?.data?.url != undefined){
        //        window.open(file?.data?.url, "_blank");
        //    }
        //}
    }, [file])

    return (
        <MainContent type={equipmentPageName}>
            <BackgroundStyle sx={{ zIndex: 0 }}>
                <LightBlueContainer>
                    <Box sx={{ display: "row" }}>
                        <BigHeading>{t("Equipment Detail")}</BigHeading>
                        <ShortBlueButton onClick={() => { navigate('/add-equipment', { state: equipmentId }); }}>{t("Edit")}</ShortBlueButton>
                    </Box>

                    <FormLabel title={t("Type")} value={equipmentById?.data?.equipmentTypeName} />
                    <FormLabel title={t("RealTimeType")} value={equipmentById?.data?.realTimeTypeId == null ? "None" : equipmentById?.data?.realTimeTypeName} />
                    {/* <FormLabel title={t("RFID No.")} value={equipmentById?.data?.rfidNumber} /> */}
                    <FormLabel title={t("Equipment No.")} value={equipmentById?.data?.equipmentNumber} />
                    <FormLabel title={t("Equipment Name")} value={equipmentById?.data?.equipmentName} />
                    <FormLabel title={t("Brand / Manufacturer")} value={equipmentById?.data?.manufacturer} />
                    <FormLabel title={t("Model No.")} value={equipmentById?.data?.modelNumber} />
                    <FormLabel title={t("Serial No.")} value={equipmentById?.data?.serialNumber} />
                    <FormLabel title={t("Purchase Date")} value={equipmentById?.data?.purchaseDate} />
                    <FormLabel title={t("Expiry Date")} value={equipmentById?.data?.expiryDate} />
                    <FormLabel title={t("Next Cal. / Cert Due Date")} value={equipmentById?.data?.certDueDate} />
                    {/*<FormLabel title={"Cal. Period"} value={equipmentById?.data?.calPeriod ? equipmentById?.data?.calPeriod + " " + ((equipmentById?.data?.calPeriodType == 0) ? "Year" : "Month") : "N/A"} />
                    */}
                    <FormLabel title={t("Certification")} value={equipmentById?.data?.certificationFile ?
                        <a onClick={() => fileUrl(equipmentById?.data?.certificationFile)} href={`/Equipment/file/${equipmentById?.data?.certificationFile?.Id}`} target="_blank" rel="noopener noreferrer">{equipmentById?.data?.certificationFile?.Name}</a>
                        : ""
                    } />
                    <FormLabel title={t("Equipment Photo")} value={equipmentById?.data?.equipmentPhoto ?
                        <a onClick={() => fileUrl(equipmentById?.data?.equipmentPhoto)} href={`/Equipment/file/${equipmentById?.data?.equipmentPhoto?.Id}`} target="_blank" rel="noopener noreferrer">{equipmentById?.data?.equipmentPhoto?.Name}</a>
                        : ""
                    } />

                    &nbsp;
                    <Box sx={{ display: "row" }}>
                        <BackButton onClick={() => { navigate('/equipment') }}>{t("Back")}</BackButton>
                    </Box>
                    &nbsp;
                </LightBlueContainer>
            </BackgroundStyle>
        </MainContent>
    );
};

export default EquipmentDetailPage;